module.exports = __webpack_public_path__ + "static/media/level3_q4.f02f7e56.png";